import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { WalletQrisHttpProvider } from './helpers/provider/repository/http-repository.provider';

const DATA_SERVICES: Provider[] = WalletQrisHttpProvider;

export const NB_CORE_PROVIDERS = [...DATA_SERVICES];

@NgModule({})
export class WalletQrisCoreModule {
  static forRoot(): ModuleWithProviders<WalletQrisCoreModule> {
    return {
      ngModule: WalletQrisCoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
